<div class="custom-ag-header">
  <div class="customOneHeaderLabel" title="{{params.displayName}}">
    {{ params.displayName }}
  </div>
</div>